// extracted by mini-css-extract-plugin
export default {"moreTitle":"moreActions_moreTitle__LENo9"};